export { default } from './stripCurlyTags';
